module.exports = "/img/_/_/_/assets/images/creeper/battle/common//3.jpg?c0a769cc8d6dea79783798f64a3a6c16";